export default __webpack_public_path__ + "static/media/movies_formatted.e500e21f.csv";